module.exports = __webpack_public_path__ + "static/BDST-Regular-c345c111df382021262f6ff079e951c7.ttf";